module.exports = __webpack_public_path__ + "img/P6.ff327751.png";